import type { DeviceHistory } from '@/features/devices/types/device-history'
import { apiPaginatedClient } from '@/lib/api/api-client'

export const apiGetDeviceHistory = (id: number | string, page = 1) =>
  apiPaginatedClient<DeviceHistory[]>(
    `/api/v1/devices/${id}/history?page=${page}`
  )
